import { MessageType } from '@infuse/cpms/charging-station/store';
import { UiTagVariant } from '@infuse/ui/domain';

enum MessageOfInterest {
  BOOTNOTIFICATION = 'BootNotification',
  STARTTRANSACTION = 'StartTransaction',
  STOPTRANSACTION = 'StopTransaction',
  AUTHORIZE = 'Authorize'
}

const messageTypeColors: Record<string, UiTagVariant> = {
  [MessageType.ERROR]: 'error',
  [MessageType.FIRE_AND_FORGET]: 'secondary'
};

const messageActionColors: Record<string, UiTagVariant> = {
  [MessageOfInterest.BOOTNOTIFICATION]: 'success',
  [MessageOfInterest.STARTTRANSACTION]: 'success',
  [MessageOfInterest.STOPTRANSACTION]: 'error',
  [MessageOfInterest.AUTHORIZE]: 'success'
};

export const useServerLogColors = () => ({
  getMessageTypeColor: (messageType: string) => messageTypeColors[messageType],
  getMessageActionColor: (messageAction: string) => messageActionColors[messageAction]
});
